<template>
  <div style="margin-top: 67px">
    <div class="mobile">
      <div class="wrapper">
        <div class="tab">
          <div @click="toggleTap(1)" v-bind:class="{activeMobile: isFirstTapOpen}">개요</div>
          <div @click="goNaverReview()" v-bind:class="{activeMobile: isSecondTapOpen}">
            <span>리뷰 {{review_number}}</span>
          </div>
          <div @click="toggleTap(3)" v-bind:class="{activeMobile: isThirdTapOpen}">FAQ</div>
        </div>
        <div class="m-apply-button-section">
          <!-- <img src="@/assets/limit-msg.png" style="position: absolute; top: -24px; height: 23pt;"/> -->
          <!-- <div style="text-align: left; margin-left: 10px;">
            <strike style="color: #9199aa; font-size: 12px; font-weight: 600;">59,000원</strike>
            <p style="color: $24292e; font-size: 15px; font-weight: 600;">0원</p>
          </div> -->
          <a href="https://smartstore.naver.com/ioswitcher/products/4625575877"><button>지금 바로 구매하기</button></a>
          <button style="background-color: #F2F6FF; box-shadow: none; color: #6F97FA" @click="addCart(3)">무료로 30일 써보기</button>
        </div>
        <div class="tabcontent" v-bind:class="{open: isFirstTapOpen}">
          <linker-summary></linker-summary>
        </div>
        <div class="tabcontent" v-bind:class="{open: isSecondTapOpen}">
        <review v-bind:reviews="review_list"
                  v-bind:productName="product_name"
                  v-bind:averageRating="review_average_rating"
                  v-bind:freetrialNumber="free_trial_number"
                  v-on:loadReview="fetchReviews"></review>
        </div>
        <div class="tabcontent" v-bind:class="{open: isThirdTapOpen}">
          <linker-spec></linker-spec>
        </div>
      </div>
    </div>
    <div class="desktop">
      <headroom>
        <header>
          <div class="wrapper topContents" id="fixedHeader">
            <div class="productTitle">
              <span class="bold">Linker</span>
            </div>
            <div class="tab-desktop">
              <span
                class="tablinks"
                @click="toggleTap(1)"
                v-bind:class="{activeDesktop: isFirstTapOpen}"
              >개요</span>
              <span
                class="tablinks"
                @click="toggleTap(2)"
                v-bind:class="{activeDesktop: isSecondTapOpen}"
              >기술 사양</span>
              <span
                class="tablinks"
                @click="toggleTap(3)"
                v-bind:class="{activeDesktop: isThirdTapOpen}"
              >자주묻는 질문</span>
            </div>
            <div>
              <button class="apply" @click="addCart(3)">무료로 30일 써보기</button>
            </div>
          </div>
        </header>
      </headroom>
      <div class="wrapper midContents">
        <div class="mid-container">
          <div class="tabcontent" v-bind:class="{open: isFirstTapOpen}">
            <linker-summary></linker-summary>
          </div>
          <div class="tabcontent" v-bind:class="{open: isSecondTapOpen}">
            <linker-spec></linker-spec>
          </div>
          <div class="tabcontent" v-bind:class="{open: isThirdTapOpen}">
            <linker-faq></linker-faq>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>

    <!-- 링커 알림 팝업 -->
    <modal
      name="linker-modal"
      :width="500"
      :reset="true"
      :pivotY="0.2"
      :adaptive="true"
      height="auto"
    >
      <div class="modal-wrapper">
        <p class="main-title bold">무료체험 물량이 소진 되었습니다.</p>
        <a href="http://bit.ly/2nFJXND">
          <button class="survey-btn">지금 바로 구매하기</button>
        </a>
      </div>
    </modal>
  </div>
</template>

<script>
import AppFooter from '../../../components/AppFooter'
import VueTinySlider from 'vue-tiny-slider'
import {headroom} from 'vue-headroom'
import { isAvailableProduct } from '../../../modules/modules'
import LinkerSummary from './LinkerSummary'
import LinkerSpec from './LinkerSpec'
import LinkerFaq from './LinkerFaq'
import Review from '../Review'

import { IO_PRODUCTS } from '../../../modules/products'
const alertOptions = {title: '', size: 'sm', okLabel: '확인'}

const PRODUCT_ID = IO_PRODUCTS.LINKER
export default {
  name: 'linker',
  components: {AppFooter, 'tiny-slider': VueTinySlider, headroom, LinkerSummary, LinkerSpec, LinkerFaq, Review},
  data () {
    return {
      isFirstTapOpen: false,
      isSecondTapOpen: false,
      isThirdTapOpen: false,
      product_name: '링커',
      review_list: [],
      review_average_rating: 0,
      reviewURL: process.env.URL_EVENT_SERVICE + '/v1/reviews/?product_id=' + PRODUCT_ID,
      free_trial_number: 0,
      review_number: 0
    }
  },
  mounted () {
    this.isFirstTapOpen = true // 첫번째 탭이 기본으로 열려있도록.
    this.fetchReviews()
    this.fetchReviewStatus(PRODUCT_ID)
    this.fetchFreetrialStatus()
  },
  methods: {
    goNaverReview: function () {
      window.location.href = 'https://m.smartstore.naver.com/ioswitcher/products/4625575877#REVIEW'
    },
    fetchFreetrialStatus: function () {
      this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/free-trials/state/')
        .then((result) => {
          this.free_trial_number = result.data.ON_FREE_TRIAL
        })
    },
    fetchReviewStatus: function (productId) {
      this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/reviews/state/?product_id=' + productId)
        .then((result) => {
          this.review_average_rating = result.data.avg.toFixed(1)
          this.review_number = result.data.count
        })
    },
    async fetchReviews () {
      if (this.reviewURL === null) {
        alert('마지막입니다.')
      }
      let response = await this.$http.get(this.reviewURL)
      for (var i = 0; i < response.data.results.length; i++) {
          this.review_list.push(response.data.results[i])
          }
      this.reviewURL = response.data.next
    },
    async addCart (productId) {
      if (this.$store.state.cartItems.findIndex(x => x.id === PRODUCT_ID) >= 0) {
        this.$dialogs.alert('이미 장바구니에 담은 제품입니다.', alertOptions)
      } else {
        let eventInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/advertising/')
        if (eventInfo.status === 204) {
          this.$dialogs.alert('무료체험 물량이 소진되었습니다. 조금만 기다려주시면 다시 진행하겠습니다.', alertOptions)
        }
        let stockInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/' + eventInfo.data.id + '/stocks/')
        if (isAvailableProduct(productId, stockInfo.data.results)) {
          this.$store.commit('insertItem', this.$store.state.products[productId - 1])
          this.$router.push({ name: 'Cart' })
        } else {
          this.$modal.show('linker-modal')
          // this.$dialogs.alert('이 제품은 무료체험을 잠시 쉬고있어요.', alertOptions)
        }
      }
    },
    toggleTap: function (division) {
      this.isFirstTapOpen = false
      this.isSecondTapOpen = false
      this.isThirdTapOpen = false
      window.scrollTo(0, 0)
      switch (division) {
        case 1:
          this.isFirstTapOpen = !this.isFirstTapOpen
          break
        case 2:
          this.isSecondTapOpen = !this.isSecondTapOpen
          break
        case 3:
          this.isThirdTapOpen = !this.isThirdTapOpen
          break
      }
    },
    closeModal: function () {
      this.$modal.hide('linker-modal')
    }
  }
}
</script>

<style scoped>

  .tab {
    overflow: hidden;
  }
  .tab div {
    padding: 10px;
  }
  @media only screen and (min-device-width : 320px) and (max-device-width : 568px) {
    .tab div {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
  .tab :nth-child(1) {
    float: left;
    width: 33%;
  }
  .tab :nth-child(2) {
    float: left;
    width: 33%;
  }
  .tab :nth-child(2) span {
    width: 100%;
    border-left: solid 1px #dee2e5;
    border-right: solid 1px #dee2e5;
  }
  .tab :nth-child(3) {
    float: left;
    width: 34%;
  }

  .tabcontent {
    display: none;
    width: 100%;
  }

  .open {
    display: block;
  }

  .midContents {
    margin-top: 130px;
  }
  .m-apply-button-section {
    z-index: 9999;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 62px;
    background-color: #f2f6ff;
    padding: 10px;
  }
  .m-apply-button-section p {
    margin: 0;
  }
  .m-apply-button-section button {
    width: 154px;
    height: 42px;
    border-radius: 6px;
    box-shadow: 0 1px 4px 0 rgba(129, 129, 129, 0.5);
    font-weight: bold;
    color: white;
    font-size: 14px;
    border: 0;
    background-color: #6f97fa;
  }

  .topContents {
    width: 100%;
    margin-top: 63px;
    padding: 10px 30px 10px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
  }
  .topContents :nth-child(2) {
    margin-left: 20px;
    margin-right: 20px;
  }
  .topContents .productTitle {
    font-size: 20px;
    width: 100px;
    text-align: left;
  }

  .topContents .tab .tablinks {
    margin: 10px;
  }
  .topContents .tab-desktop span {
    padding: 8px 24px;
    cursor: pointer;
  }
  .mid-container {
    padding:  0 30px 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .desktop section {
    margin-bottom: 30px;
  }

 .apply {
  padding: 10px 19px;
  position: relative;
  vertical-align: middle;
  font-family: "Noto Sans KR", sans-serif;
  letter-spacing: -0.4px;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  border-radius: 2px;
  background-color: #6f97fa;
  text-decoration: none;
  display: inline-block;
  border: 0;
  outline: 0;
  cursor: pointer;
}
.apply:hover {
  background-color: #5686fe;
}

.activeMobile {
  font-weight: bold;
  border-bottom: 4px solid #3d4953;
}
.activeDesktop {
  border-radius: 20px;
  border: solid 1px #6f97fa;
  font-weight: bold;
  color: #6f97fa;
  padding: 8px 23px !important;
}

.hero {
  background: url("../../../assets/linker/linker-hero.png") no-repeat center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}

  .hero span {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.58;
    letter-spacing: 0;
    color: #ffffff;
  }

  .description-title {
    font-size: 24px;
    font-weight: 700;

  }
  .description-subtitle {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.62;
    margin-top: 13px;
  }
.center-title {
  font-size: 24px;
  letter-spacing: 0;
  font-weight: 700;
}
.center-subtitle {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.62;
  margin-top: 15px;
}

.button-wrapper {
  display: inline-block;
  margin-top: 36px;
}
.button-wrapper div {
  margin: 14px;
}
.app-button {
  width: 158px;
  height: 50px;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-button img {
  margin-right: 7px;
}
.desktop .usecase-contents {
  text-align: left;
}
.desktop .usecase-contents p {
  font-weight: 400;
}
.usecase-contents {
  font-size: 16px;
  line-height: 1.71;
  margin-top: 39px;
}
.usecase-contents span {
  font-weight: bold;
}
.usecase-contents p {
  margin-top: 9px;
}
.usecase-contents a {
  font-size: 12px;
  letter-spacing: -0.4px;
  color: #3d4953;
  text-decoration: underline;
}

.main-title-container {
  text-align: left;
  margin-left: 10%;
}
.m-hero {
  background: url("../../../assets/linker/m-linker-hero.png") no-repeat center center;
  background-size: cover;
  min-height: 470px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}
.m-hero h1 {
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
}
.m-hero p {
  margin-top: 24px;
  font-size: 18px;
  line-height: 1.56;
  color: #ffffff;
}

.m-description-container {
  text-align: left;
}
.m-description-container span {
  font-size: 18px;
  line-height: 1.56;
  letter-spacing: 0;
}
.m-description-container p {
  margin: 23px 0px 0px 0px;
  font-size: 14px;
  line-height: 1.71;
  letter-spacing: 0;
}

  .app-button {
    width: 158px;
    height: 50px;
    border-radius: 2px;
    border: solid 1px #a5a5a5;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .app-button img {
    margin-right: 7px;
  }

  .m-usecase {
    background-color: #fafafa;
    padding: 73px 0px 110px 25px;
  }

  .m-usecase-container {
    text-align: left;
  }
  .m-usecase-container span {
    line-height: 1.56;
  }
  .m-usecase-contents {
    font-size: 14px;
    line-height: 1.71;
    margin-top: 39px;
  }
  .m-usecase-contents span {
    font-weight: bold;
  }
  .m-usecase-contents p {
    margin-top: 9px;
  }
  .m-usecase-contents a {
    font-size: 12px;
    letter-spacing: -0.4px;
    color: #3d4953;
    text-decoration: underline;
  }

  .modal-wrapper {
    text-align: center;
    z-index: 999999999;
    padding: 30px;
  }
  .main-title {
    font-size: 18px;
  }

  .sub-title {
    font-size: 20px;
  }
  .month {
    border-bottom: 1px;
    font-weight: bold;
  }

  .v--modal-overlay {
    z-index: 9999999;
    background: rgba(0, 0, 0, 0.4);
  }

  .survey-btn {
    width: 206px;
    height: 36px;
    background-color: transparent;
    border: solid 1px #a5a5a5;
    cursor: pointer;
  }

  .limit-msg {
    position: absolute;
    top: -24px;
    height: 23pt;
  }
</style>



// WEBPACK FOOTER //
// src/components/products/linker/Linker.vue